import React, { useState, useEffect } from 'react';
import { OnboardingCard } from './OnboardingCard';
import { connect, useSelector } from 'react-redux';
import { withStyles, Grid, Typography } from '@material-ui/core';
import { CardModuleUI, ToggleUI } from '../../common';
import { MessageStepsDone } from './MessageStepsDone';
import {
  tiendaObtener,
  categoriasObtener,
  ventaObtenerVentas,
  metodospagoObtener,
  metodosenvioObtener,
  productoObtenerProductos,
} from '../../../store/actions';
import { initial_onboarding_cards, ob_card_states } from './onboardingState';
import { selectTreatmentValue } from '@splitsoftware/splitio-redux';
import { MessageStepsDoneExperiment } from './MessageStepsDoneExperiment';
import { SpinnerProgress } from '../../productos-importar/subcomponents/SpinnerProgress';

//e_s = endpoint state
const e_s = {
  with_data: 'with_data',
  not_checked: 'not_checked',
  without_data: 'without_data',
};

const Onboarding_ = ({
  classes,
  getVentas,
  getTienda,
  getProductos,
  getCategorias,
  getMetodosPago,
  getMetodosEnvio,
  handleOnboardingError,
}) => {
  const { trialStore, idCountry, idTienda, domainStore, splitio } = useSelector(
    (state) => ({
      splitio: state.splitio,
      idTienda: state.tienda.idTienda,
      domainStore: state.auth.d_nombre,
      trialStore: state.tienda.t_prueba,
      idCountry: state.tienda.Country_idCountry || 'ARG',
    })
  );

  //Estado del consumo de los endpoints
  const [allCardsDone, setAllCardsDone] = useState(false);
  const [ventas_check, setVentasCheck] = useState(e_s.not_checked);
  const [disenio_check, setDisenioCheck] = useState(e_s.not_checked);
  const [allEndpointsChecked, setAllEndpointsChecked] = useState(false);
  const [productos_check, setProductosCheck] = useState(e_s.not_checked);
  const [categorias_check, setCategoriasCheck] = useState(e_s.not_checked);
  const [metodos_pago_check, setMetodosPagoCheck] = useState(e_s.not_checked);
  const [metodos_envio_check, setMetodosEnvioCheck] = useState(e_s.not_checked);

  const [cantidadVentas, setCantidadVentas] = useState(0);

  const trment = selectTreatmentValue(
    splitio,
    'experiment_empretienda_panel_onboarding',
    idTienda
  );

  const showExperimentMessage = trment === 'on';

  useEffect(() => {
    const ventasData = showExperimentMessage
      ? {
          page: 0,
          v_estado_pago: 1,
        }
      : {
          page: 0,
        };

    getVentas(ventasData, (err, resp) => {
      if (!err) {
        if (resp.data && resp.data.length > 0) {
          setVentasCheck(e_s.with_data);
          setCantidadVentas(resp.data.length);
        } else {
          setCantidadVentas(0);
          setVentasCheck(e_s.without_data);
        }
      } else {
        handleOnboardingError(err);
      }
    });
  }, [showExperimentMessage]);

  useEffect(() => {
    getCategorias((err, resp) => {
      if (!err) {
        if (resp.data && resp.data.length > 0) {
          setCategoriasCheck(e_s.with_data);
          //si hay categorías, hay que ver si hay productos etc
        } else {
          setCategoriasCheck(e_s.without_data);
        }
      } else {
        handleOnboardingError(err);
      }
    });

    getProductos(
      {
        page: 0,
      },
      (err, resp) => {
        if (!err) {
          if (resp.data && resp.data.length > 0) {
            setProductosCheck(e_s.with_data);
            //si hay productos, hay que ver si eligió un diseño
          } else {
            setProductosCheck(e_s.without_data);
          }
        } else {
          handleOnboardingError(err);
        }
      }
    );

    getTienda((err, resp) => {
      if (!err) {
        if (resp.data && resp.data.t_logo !== null) {
          setDisenioCheck(e_s.with_data);
          //si hay diseño, ver si tien medios de pago
        } else {
          setDisenioCheck(e_s.without_data);
        }
      } else {
        handleOnboardingError(err);
      }
    });

    getMetodosPago((err, resp) => {
      if (!err) {
        if (
          resp.data &&
          (resp.data.mp_mercadopago === 1 ||
            resp.data.mp_mobbex === 1 ||
            resp.data.mp_deposito === 1 ||
            resp.data.mp_uala === 1 ||
            resp.data.mp_efectivo === 1)
        ) {
          setMetodosPagoCheck(e_s.with_data);
        } else {
          setMetodosPagoCheck(e_s.without_data);
        }
      } else {
        handleOnboardingError(err);
      }
    });

    getMetodosEnvio((err, resp) => {
      if (!err) {
        if (
          resp.data &&
          (resp.data.me_retiro_local === 1 ||
            resp.data.me_oca === 1 ||
            resp.data.me_correo_argentino === 1 ||
            resp.data.me_mercadoenvios === 1 ||
            resp.data.me_epick === 1 ||
            resp.data.me_emprepack === 1 ||
            resp.data.me_personalizados === 1)
        ) {
          setMetodosEnvioCheck(e_s.with_data);
        } else {
          setMetodosEnvioCheck(e_s.without_data);
        }
      } else {
        handleOnboardingError(err);
      }
    });
  }, []);

  useEffect(() => {
    if (
      !allEndpointsChecked &&
      ventas_check !== e_s.not_checked &&
      disenio_check !== e_s.not_checked &&
      productos_check !== e_s.not_checked &&
      categorias_check !== e_s.not_checked &&
      metodos_pago_check !== e_s.not_checked &&
      (metodos_envio_check !== e_s.not_checked || idCountry === 'COL')
    ) {
      setAllEndpointsChecked(true);
    }

    if (
      !allCardsDone &&
      categorias_check === e_s.with_data &&
      productos_check === e_s.with_data &&
      disenio_check === e_s.with_data &&
      metodos_pago_check === e_s.with_data &&
      (metodos_envio_check === e_s.with_data || idCountry === 'COL')
    ) {
      setAllCardsDone(true);
    }
  }, [
    ventas_check,
    disenio_check,
    productos_check,
    categorias_check,
    metodos_pago_check,
    metodos_envio_check,
  ]);

  const listOnBoardingSteps = (() => {
    const initialCardsWithCountry = initial_onboarding_cards.map((card) => {
      const newCard = {
        ...card,
        idCountry: idCountry,
      };
      return newCard;
    });

    if (idCountry === 'COL') {
      return initialCardsWithCountry.filter(
        (card) => card.key !== 'choose_delivery_method'
      );
    }

    return initialCardsWithCountry;
  })();

  const { done, prev_step_not_done } = ob_card_states;
  const cardStates = {
    create_categories:
      categorias_check === e_s.with_data ? done : prev_step_not_done,
    upload_products:
      productos_check === e_s.with_data ? done : prev_step_not_done,
    select_a_design:
      disenio_check === e_s.with_data ? done : prev_step_not_done,
    config_payment_method:
      metodos_pago_check === e_s.with_data ? done : prev_step_not_done,
    choose_delivery_method:
      metodos_envio_check === e_s.with_data ? done : prev_step_not_done,
  };

  return (
    <ToggleUI show={cantidadVentas <= 1}>
      <ToggleUI show={!allEndpointsChecked}>
        <div className={classes.spinner_centered}>
          <SpinnerProgress />
        </div>
      </ToggleUI>
      <ToggleUI show={allEndpointsChecked && allCardsDone}>
        <ToggleUI show={trialStore === 1 && showExperimentMessage}>
          <MessageStepsDoneExperiment
            title="¡Felicidades! Estás a un paso de lograr tu primera venta"
            cantidadVentas={cantidadVentas}
            domainStore={`https://${domainStore}`}
          />
        </ToggleUI>
        <ToggleUI show={!showExperimentMessage}>
          <MessageStepsDone title="¡Felicitaciones!" />
        </ToggleUI>
      </ToggleUI>
      <ToggleUI show={allEndpointsChecked && !allCardsDone}>
        <CardModuleUI>
          <Typography
            variant="h3"
            color="primary"
            className={classes.container_title}
          >
            Tu tienda en simples pasos
          </Typography>
          <Typography variant="h3" className={classes.container_subtitle}>
            Se puede hacer clic en estos pasos y dejar lista tu tienda para tu
            primera venta.
          </Typography>
          <Grid container>
            {listOnBoardingSteps.map((item, i) => {
              const newOnboardingCard = {
                ...item,
                step_state: cardStates[item.key],
              };
              return (
                <OnboardingCard key={i} onboarding_card={newOnboardingCard} />
              );
            })}
          </Grid>
        </CardModuleUI>
      </ToggleUI>
    </ToggleUI>
  );
};

const styles = (theme) => ({
  container_title: {
    fontWeight: '500',
    fontSize: '1.125rem',
    marginBottom: '40px',
  },
  container_subtitle: {
    fontWeight: '400',
    fontSize: '1.125rem',
    marginBottom: '20px',
    color: '#383838',
  },
  spinner_centered: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    getTienda: (callback) => dispatch(tiendaObtener(callback)),
    getCategorias: (callback) => dispatch(categoriasObtener(callback)),
    getMetodosPago: (callback) => dispatch(metodospagoObtener(callback)),
    getMetodosEnvio: (callback) => dispatch(metodosenvioObtener(callback)),
    getVentas: (data, callback) => dispatch(ventaObtenerVentas(data, callback)),
    getProductos: (data, callback) =>
      dispatch(productoObtenerProductos(data, callback)),
  };
};

export const Onboarding = withStyles(styles)(
  connect(null, mapDispatchToProps)(Onboarding_)
);
